export type SegmentEventProperties = {
  cta?: string;
  location?: string;
  path?: string;
  action?: string;
  selection?: string;
  formName?: string;
  fieldName?: string;
  status?: string;
  tabIndex?: number; // Tabs
  tabName?: string; // Tabs
  percentage?: number; //for scroll depth
};

export type TrackingProps = {
  event: string;
  properties: SegmentEventProperties;
};

export function trackEvent(
  eventName: string,
  properties: SegmentEventProperties
) {
  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.track(eventName, properties);
  }
}
